import { booleanOptions, Input, MultiSearchForm } from "@";
import type { SearchValues } from "../types";

interface MultiSearchProps {
  onSubmit: () => void;
  search: {
    show: boolean;
    values: SearchValues;
  };
  updateSearch: (params: { show?: boolean; values?: SearchValues }) => void;
  onReset: () => void;
}

const MultiSearch = ({
  onSubmit,
  search,
  updateSearch,
  onReset,
}: MultiSearchProps) => {
  const handleInputChange = (field: keyof SearchValues, value: string) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-3"
      reset={onReset}
    >
      <Input
        star
        label="اسم الصفحة"
        value={search.values.name}
        change={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleInputChange("name", e.target.value)
        }
      />

      <Input
        star
        label="نشط"
        type="select"
        list={booleanOptions}
        value={search.values.isActive}
        change={(e: React.ChangeEvent<HTMLSelectElement>) =>
          handleInputChange("isActive", e.target.value)
        }
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
